export default __webpack_public_path__ + "static/media/logo.1b2858a9.png";